const isProduction = process.env.NODE_ENV === 'production';
const isVercel = process.env.VERCEL === '1' || process.env.VERCEL_ENV !== undefined;

interface Logger {
  log: (...args: any[]) => void;
  error: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  info: (...args: any[]) => void;
}

const logger: Logger = {
  log: (...args: any[]) => {
    if (!isProduction || isVercel) {
      console.log(...args);
    }
  },
  error: (...args: any[]) => {
    if (!isProduction || isVercel) {
      console.error(...args);
    }
  },
  warn: (...args: any[]) => {
    if (!isProduction || isVercel) {
      console.warn(...args);
    }
  },
  info: (...args: any[]) => {
    if (!isProduction || isVercel) {
      console.info(...args);
    }
  }
};

export default logger;